export interface StatusConfig {
  text: string;
  color: string;
  backgroundColor: string;
}

export const STATUS_CONFIG: Record<string, StatusConfig> = {
  عالی: {
    text: "عالی",
    color: "#039855",
    backgroundColor: "#D1FADF"
  },
  خوب: {
    text: "خوب",
    color: "#125CE7",
    backgroundColor: "#F4F8FF"
  },
  "قابل قبول": {
    text: "قابل قبول",
    color: "#FF6A00",
    backgroundColor: "#FFF0E6"
  },
  متوسط: {
    text: "قابل قبول",
    color: "#FF6A00",
    backgroundColor: "#FFF0E6"
  },
  "نیاز به تلاش": {
    text: "نیاز به تلاش",
    color: "#D92D20",
    backgroundColor: "#FEF3F2"
  },
  "نیاز به تمرین": {
    text: "نیاز به تمرین",
    color: "#D92D20",
    backgroundColor: "#FEF3F2"
  },
  ضعیف: {
    text: "نیاز به تلاش",
    color: "#D92D20",
    backgroundColor: "#FEF3F2"
  },
  نامشخص: {
    text: "نامشخص",
    color: "#667085",
    backgroundColor: "#FCFCFD"
  }
};

export const DEFAULT_STATUS: StatusConfig = {
  text: "نامشخص",
  color: "#667085",
  backgroundColor: "#FCFCFD"
};
